
// Animations

import DescribeYourFence from './DescribeYourFence';
import DescribeYourHome from './DescribeYourHome';
import DogIndoorsOutdoors from './DogIndoorsOutdoors';
import DogLookingUp from './DogLookingUp';
import DogMedication from './DogMedication';
import DogSleeping from './DogSleeping';
import DogSleepingIndoors from './DogSleepingIndoors'
import DogsVisit from './DogsVisit';
import HowActive from './HowActive';
import HowBusy from './HowBusy';
import HowMuchTraining from './HowMuchTraining';
import ManArmLeash from './ManArmLeash';
import ManDogBall from './ManDogBall';
import OffLeashPark from './OffLeashPark';
import OtherAnimals from './OtherAnimals';
import PurpleDog from './PurpleDog';
import YoungestFamily from './YoungestFamily';

const questionAnimation = {
  1: DogLookingUp,
  2: ManDogBall,
  3: HowBusy,
  4: YoungestFamily,
  5: PurpleDog,
  6: DogsVisit,
  7: DogsVisit,
  8: OtherAnimals,
  9: HowActive,
  10: HowMuchTraining,
  11: DogSleeping,
  12: ManArmLeash,
  13: OffLeashPark,
  14: DogIndoorsOutdoors,
  15: DogSleepingIndoors,
  16: DogMedication,
  17: DescribeYourHome,
  18: DescribeYourFence
}

// Exports
export default questionAnimation;
